@if (isSelected()) {
  <input-wrap class="visually-hidden">
  <input type="checkbox"
    [(ngModel)]="valid"
    name="stripe"
    required />
</input-wrap>
}

<div class="is-required w-12"
  [ngClass]="{'m-t m-b': componentReady, 'stripe-submitted' : submitted || onBlur}">

  <div class="stripe-input-container flex-top"
    [class.is-invalid]="cardNumberError"
    [ngClass]="{'no' : !componentReady, 'flex-column w-12' : componentReady}">
    <label class="c1 p-l-1 p-r-1 left-2 bg-col-51 stripe-label"
    for="stripe-number">{{'Card Number' | translate}}</label>
    <div class="stripe-input input w-12 flex flex-middle">
      <div #cardNumberContainer
      id="stripe-number"></div>
      <div class="flex">
        <span [class._icon-hidden]="!displayCardIcon('visa')"
        class="payment-method-logo payment-method-logo--visa m-r-1"></span>
        <span [class._icon-hidden]="!displayCardIcon('mastercard')"
        class="payment-method-logo payment-method-logo--mastercard m-r-1"></span>
        <span [class._icon-hidden]="!displayCardIcon('amex')"
        class="payment-method-logo payment-method-logo--amex m-r-1"></span>
      </div>
    </div>
    <div class="flex flex-column c2 flex-top p-t-1">
      <span class="col-2 stripe-input__error">{{cardNumberError | translate}}</span>
    </div>
  </div>
  <div class="flex flex-row w-12"
    [ngClass]="{'m-t-6' : componentReady}">
    <div class="stripe-input-container flex-top p-r-3"
      [class.is-invalid]="cardExpiryError"
      [ngClass]="{'no' : !componentReady, 'w-6 flex-column' : componentReady}">
      <label class="c1 p-l-1 p-r-1 left-2 bg-col-51 stripe-label"
      for="stripe-expiry">{{'Expiration Date' | translate}}</label>
      <div class="w-12 stripe-input input"
        #cardExpiryContainer
      id="stripe-expiry"></div>
      <div class="flex flex-column c2 flex-top p-t-1">
        <span class="col-2 stripe-input__error">{{cardExpiryError | translate}}</span>
      </div>

    </div>
    <div class="stripe-input-container flex-top"
      [class.is-invalid]="cardCvcError"
      [ngClass]="{'no' : !componentReady, 'flex-column w-6' : componentReady}">
      <label class="c1 p-l-1 p-r-1 left-2 bg-col-51 stripe-label"
      for="stripe-cvc">{{'CVV' | translate}}</label>
      <div class="stripe-input input w-12 flex flex-middle">
        <div class="w-12"
          #cardCvcContainer
        id="stripe-cvc"></div>
        <div><span class="_cvv-logo m-r-1"></span></div>
      </div>
      <div class="flex flex-column c2 flex-top p-t-1">
        <span class="col-2 stripe-input__error">{{cardCvcError | translate}}</span>
      </div>

    </div>
  </div>

  @if (componentReady && useSaveCard()) {
    <div class="m-t-6 m-b-2 col-12 address-fieldset"
      >
      <checkbox name="save_card"
        [(ngModel)]="saveCard"
        (ngModelChange)="detectChanges()"><span>{{'Securely save details for future orders' |
      translate}}</span>
    </checkbox>
  </div>
}
</div>

@if (scriptStatus.error) {
  <span class="col-2"
  >{{scriptStatus.error}}</span>
}
